module.exports = __webpack_public_path__ + "04b5011df6bc9ca95c65d57f31e96e65.png";